import { Emitter } from '@/shared/plugins/stats/emitter';
import EventType from './event-type';

export default class GemiusEmitter extends Emitter {
  constructor(stats) {
    super();
    this.stats = stats;
  }

  pageView({ pagePath }) {
    const extraData = {
      event: EventType.PAGE_VIEW,
      pagePath,
      pageTitle: document.title,
    };
    Object.keys(extraData).forEach((k) => extraData[k] == null && delete extraData[k]);
    const extraDataArray = Object.entries(extraData)
      .map(([key, value]) => {
        return `${key}=${value}`;
      });
    window.gemius_hit(window.pp_gemius_id, ...extraDataArray);
  }
}
